module.exports = __webpack_public_path__ + "static/media/p4_1.39c83bae.png";